export * from './termsAndPrivacy'
